interface PaginationProps {
  currentPage: number
  totalPages: number
  maxPagesVisible: number
}

type Range = (number | string)[];

export function usePagination () {
  const generatePageBlocks = ({ currentPage, totalPages, maxPagesVisible = 5 }: PaginationProps): Range => {
    const halfVisiblePages = Math.floor(maxPagesVisible / 2);
    const range: Range = [1];

    const startPage = Math.max(2, currentPage - halfVisiblePages); // Start center range
    const endPage = Math.min(totalPages - 1, currentPage + halfVisiblePages); // Ends center range

    // Add ellipsis in the middle if necessary
    if (currentPage - halfVisiblePages > 2) {
      range.push('...');
    }

    for (let i = startPage; i <= endPage; i++) {
      range.push(i);
    }
    if (currentPage + halfVisiblePages < totalPages - 1) {
      range.push('...');
    }

    // Add the last page
    if (totalPages > 1) range.push(totalPages);

    return range;
  };

  const calculateTotalPages = (items: number, itemsPerPage: number) => {
    if (itemsPerPage <= 0) {
      throw new Error('The number of items should be greater than zero.');
    }
    return Math.ceil(items / itemsPerPage);
  };

  return {
    generatePageBlocks,
    calculateTotalPages,
  };
}
